import React from 'react';
import * as Icons from '../../Icons//index.js';
import { IconWrapper } from './styles.js';
const FeatherIcons = (props) => {
    const elements = Object.keys(Icons);
    const elms = props.query
        ? elements.filter((c) => c.toLowerCase().indexOf(props.query.toLowerCase()) !== -1)
        : elements;
    return (React.createElement("div", null, elms.map((x) => (
    // @ts-ignore
    React.createElement(IconWrapper, { title: x, children: Icons[x]({}) })))));
};
export const FeatherIconsUnqiueMatch = (props) => {
    const elements = Object.keys(Icons);
    const ele = props.query
        ? elements.find((c) => c.toLowerCase() === props?.query?.toLowerCase())
        : 'Archive';
    // @ts-ignore
    return Icons[ele]({});
};
export default FeatherIcons;
//# sourceMappingURL=FeatherIcons.js.map